import React from "react";
import { PROCESS_STEPS } from "../data/site";

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="overline mb-4">Export Process</div>
          <h2 className="section-heading text-navy text-3xl md:text-4xl lg:text-5xl font-bold">
            From inquiry to delivery — a transparent 10-step process.
          </h2>
        </div>

        <div className="relative">
          {/* Vertical line for md+ */}
          <div className="hidden md:block absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-px bg-slate-200" />

          <div className="space-y-6 md:space-y-0">
            {PROCESS_STEPS.map((s, i) => {
              const left = i % 2 === 0;
              return (
                <div
                  key={s.n}
                  data-testid={`process-step-${s.n}`}
                  className="md:grid md:grid-cols-2 md:gap-16 items-center relative md:min-h-[120px]"
                >
                  {/* Number dot */}
                  <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 items-center justify-center z-10">
                    <div className="w-12 h-12 rounded-full bg-navy text-white font-display font-bold flex items-center justify-center ring-8 ring-white shadow-lg">
                      {s.n}
                    </div>
                  </div>

                  {left ? (
                    <>
                      <div className="md:text-right md:pr-14 py-4">
                        <div className="flex md:hidden items-center gap-3 mb-2">
                          <div className="w-10 h-10 rounded-full bg-navy text-white font-display font-bold flex items-center justify-center text-sm">
                            {s.n}
                          </div>
                          <div className="font-display text-xl text-navy font-bold">{s.title}</div>
                        </div>
                        <div className="hidden md:block font-display text-2xl text-navy font-bold">
                          {s.title}
                        </div>
                        <p className="mt-2 text-slate-600 leading-relaxed">{s.desc}</p>
                      </div>
                      <div />
                    </>
                  ) : (
                    <>
                      <div />
                      <div className="md:pl-14 py-4">
                        <div className="flex md:hidden items-center gap-3 mb-2">
                          <div className="w-10 h-10 rounded-full bg-navy text-white font-display font-bold flex items-center justify-center text-sm">
                            {s.n}
                          </div>
                          <div className="font-display text-xl text-navy font-bold">{s.title}</div>
                        </div>
                        <div className="hidden md:block font-display text-2xl text-navy font-bold">
                          {s.title}
                        </div>
                        <p className="mt-2 text-slate-600 leading-relaxed">{s.desc}</p>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
